import React from 'react';
interface SkeletonTableProps {
  rows?: number;
  columns?: number;
  hasHeader?: boolean;
  className?: string;
}
const SkeletonTable: React.FC<SkeletonTableProps> = ({
  rows = 5,
  columns = 5,
  hasHeader = true,
  className = ''
}) => {
  return <div className={`rounded-lg border border-gray-200 bg-white shadow-sm animate-pulse ${className}`} data-id="element-1175">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-1176">
        <div className="h-6 bg-gray-200 rounded w-1/4" data-id="element-1177"></div>
      </div>
      <div className="p-6" data-id="element-1178">
        <div className="overflow-x-auto" data-id="element-1179">
          <table className="w-full" data-id="element-1180">
            {hasHeader && <thead data-id="element-1181">
                <tr className="bg-gray-50" data-id="element-1182">
                  {Array(columns).fill(0).map((_, index) => <th key={`header-${index}`} className="px-6 py-3" data-id="element-1183">
                        <div className="h-4 bg-gray-200 rounded w-full" data-id="element-1184"></div>
                      </th>)}
                </tr>
              </thead>}
            <tbody data-id="element-1185">
              {Array(rows).fill(0).map((_, rowIndex) => <tr key={`row-${rowIndex}`} className="border-t border-gray-200" data-id="element-1186">
                    {Array(columns).fill(0).map((_, colIndex) => <td key={`cell-${rowIndex}-${colIndex}`} className="px-6 py-4" data-id="element-1187">
                          <div className="h-4 bg-gray-200 rounded w-full" data-id="element-1188"></div>
                        </td>)}
                  </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default SkeletonTable;